import { IConfig } from './../Config';

export default class WebUtils {
    public configuration: IConfig;

    constructor(configuration: IConfig){
        this.configuration = configuration;
    }

    public isOnline(): boolean {
        return navigator.onLine;
    }
    
    public ajax(url: string, doneCallback: Function, errorCallback: Function, data?: Object, sendAsJsonBody: boolean = false, withCredentials: boolean = false, jsonResponse: boolean = true): void {
        this.get(
            url, 
            data => doneCallback(data), 
            error => errorCallback(error), 
            data,
            sendAsJsonBody,
            withCredentials,
            jsonResponse
        );
    }

    public static getS3FileContent(url: string, successHandler: Function, errorHandler: Function){
        if(window.fetch){
            fetch(url, {
                mode: 'cors',
                method: 'get'
            }).then(response => {
                response.text()
                        .then(text => successHandler(text))
                        .catch(e => errorHandler(e));
            }).catch(e => errorHandler(e));
        }
        else if((window as any).$) {
            $.ajax({ url: url, crossDomain: true}).done((html: string) => successHandler(html)).fail(e => errorHandler(e));
        }
        else {
            const xhr = new XMLHttpRequest();

            xhr.open('get', url, true);

            xhr.setRequestHeader("Content-Type", "application/html;charset=UTF-8");
            xhr.setRequestHeader("accept", "*/*");
            xhr.setRequestHeader("accept-encoding", "gzip, deflate, br");
            xhr.setRequestHeader("cache-control", "no-cache");
            xhr.setRequestHeader("sec-fetch-dest", "empty");
            xhr.setRequestHeader("sec-fetch-mode", "cors");
            xhr.setRequestHeader("sec-fetch-site", "cross-site");

            xhr.onreadystatechange = () => {
                if (xhr.readyState == 4) { // `DONE`
                    if (xhr.status == 200) {                    
                        successHandler && successHandler(xhr.responseText);
                    } else {
                        errorHandler && errorHandler(status);
                    }
                }
            };
            
            xhr.send();
        }        
    }

    public delete(url: string, successHandler: Function, errorHandler: Function, data: Object, withCredentials: boolean = true, jsonResponse: boolean = true){
        const win = window as any;
        
        if(win.$){
            this.jQueryInteractWithOurBackend(url, "delete", successHandler, errorHandler, data, jsonResponse, true, false, withCredentials);
            return;
        }
        
        const xhr = new XMLHttpRequest();

        xhr.open('post', url, true);
        
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8');

        if(withCredentials){
            xhr.withCredentials = true;
        }
        
        xhr.onreadystatechange = () => {
            let status;
            let data;
            if (xhr.readyState == 4) { // `DONE`
                status = xhr.status;
                if (status == 200) {
                    try {
                        data = jsonResponse ? JSON.parse(xhr.responseText) : xhr.responseText;
                    }
                    catch(e){
                        errorHandler && errorHandler(e);
                        return;
                    }
                    
                    successHandler && successHandler(data);
                } else {
                    errorHandler && errorHandler(status);
                }
            }
        };

        let encodedData = "";
        for(let prop in data){
            if(encodedData) {
                encodedData += "&";
            }

            encodedData += `${prop}=${encodeURIComponent(data[prop])}`; 
        }

        xhr.send(encodedData);               
    }
    
    public post(url: string, successHandler: Function, errorHandler: Function, data: Object, withCredentials: boolean = true, jsonResponse: boolean = true, jsonRequest: boolean = false){
        const win = window as any;
        
        if(win.$){
            this.jQueryInteractWithOurBackend(
                url, 
                "post", 
                successHandler, 
                errorHandler, 
                data, 
                jsonResponse, 
                true, jsonRequest, 
                withCredentials
            );
            return;
        }
        
        const xhr = new XMLHttpRequest();

        xhr.open('post', url, true);
        
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8');

        if(withCredentials){
            xhr.withCredentials = true;
        }
        
        xhr.onreadystatechange = () => {
            let status;
            let data;
            if (xhr.readyState == 4) { // `DONE`
                status = xhr.status;
                if (status == 200) {
                    try {
                        data = jsonResponse ? JSON.parse(xhr.responseText) : xhr.responseText;
                    }
                    catch(e){
                        errorHandler && errorHandler(e);
                        return;
                    }
                    
                    successHandler && successHandler(data);
                } else {
                    errorHandler && errorHandler(status);
                }
            }
        };

        let encodedData = "";
        for(let prop in data){
            if(encodedData) {
                encodedData += "&";
            }

            encodedData += `${prop}=${encodeURIComponent(data[prop])}`; 
        }

        xhr.send(encodedData);               
    }

    private get(url: string, successHandler: Function, errorHandler: Function, data?: Object, sendAsJsonBody: boolean = false, withCredentials: boolean = false, jsonResponse: boolean = true) {
        const win = window as any;
        if(win.$){
            this.jQueryInteractWithOurBackend(url, sendAsJsonBody ? "post" : "get", successHandler, errorHandler, data, jsonResponse, true, sendAsJsonBody, withCredentials);
            return;
        }

        const xhr = new XMLHttpRequest();

        if(data && data instanceof Object && !sendAsJsonBody){
            url += "?" + this.serializeObject(data);
        }

        sendAsJsonBody ? xhr.open('post', url, true)
                       : xhr.open('get', url, true);
        
        //xhr.responseType = 'json';
        if(sendAsJsonBody){
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
        }
        else {
            xhr.setRequestHeader("Content-Type", "application/text;charset=UTF-8");
        }

        if(withCredentials){
            xhr.withCredentials = true;
        }
        
        xhr.onreadystatechange = () => {
            let status;
            let data;
            if (xhr.readyState == 4) { // `DONE`
                status = xhr.status;
                if (status == 200) {
                    try {
                        data = jsonResponse ? JSON.parse(xhr.responseText) : xhr.responseText;
                    }
                    catch(e){
                        errorHandler && errorHandler(e);
                        return;
                    }
                    
                    successHandler && successHandler(data);
                } else {
                    errorHandler && errorHandler(status);
                }
            }
        };

        sendAsJsonBody ? xhr.send(JSON.stringify(data))
                       : xhr.send();
    }

    public jQueryInteractWithOurBackend(url: string, method: string, doneCallback: Function, failCallback: Function,
                                        data?: any, recieveJSON = true, async = true, sendJSON = false, withCredentials = true) {
                                            
        data = Object.assign({}, data);

        const config: any = {
            url: url,
            type: method,
            async: async,
            data: sendJSON ? JSON.stringify(data || {}) : (data || {}),
            dataType: recieveJSON ? "json" : "text",
            crossDomain: true
        };

        if(withCredentials){
            config.xhrFields = {
                withCredentials: true
            };
        }

        if(sendJSON){
            config.contentType = 'application/json; charset=utf-8';
        }

        return $.ajax(config)
                .done(data => doneCallback(data))
                .fail(error => failCallback(error));
    }

    public configure(configuration: IConfig){
        this.configuration = configuration;
    }

    public getAbsoluteLivebookAwsUrl(relativeUrl: string){
        return this.getAbsoluteUrl(this.configuration.aws.livebook, relativeUrl);
    }

    public getAbsoluteBackendUrl(relativeUrl: string){
        return this.getAbsoluteUrl(this.configuration.backend.base, relativeUrl);
    }

    public getAbsoluteBackendLivebookUrl(relativeUrl: string){
        return this.getAbsoluteUrl(this.configuration.backend.livebook, relativeUrl);
    }

    public getAbsoluteBackendLivevideoUrl(relativeUrl: string){
        return this.getAbsoluteUrl(this.configuration.backend.livevideo, relativeUrl);
    }

    private getOverrideDomain(baseUrl: string): string {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('forceQA')) {
            return 'https://livebook-qa.manning.com';
        }
        if (urlParams.has('forceProd')) {
            return 'https://livebook.manning.com';
        }
        return baseUrl;
    }

    private getAbsoluteUrl(baseUrl: string, relativeUrl: string): string {
        let absoluteUrl = this.getOverrideDomain(baseUrl); 
    
        if (!absoluteUrl.endsWith("/") && !relativeUrl.startsWith("/")) {
            absoluteUrl += "/";
        }
    
        return absoluteUrl + relativeUrl;
    }

    public static getAbsoluteLink(baseUrl: string, relativeUrl: string){
        if(!baseUrl) { return relativeUrl; }
        if(!relativeUrl) { return baseUrl; }
        
        let link = baseUrl;

        if(!baseUrl.endsWith("/") && !relativeUrl.startsWith("/")){
            link += "/";
        }
        else if(baseUrl.endsWith("&") && relativeUrl.startsWith("/")){
            link = link.substr(0, link.length - 1);
        }

        return link + relativeUrl;
    }

    public static isLivebookLink(relativeUrl: string){
        if(!relativeUrl) { return false; }

        return relativeUrl.indexOf("/book/") != -1;
    }

    public static isLivevideoLink(relativeUrl: string){
        if(!relativeUrl) { return false; }

        return relativeUrl.indexOf("module/") != -1;
    }

    public getAwsPublic(relativePath: string = ""){
        return this.configuration.aws.livebook + (relativePath || "");
    }

    private serializeObject(obj: any){
        if(!obj) { return ""; }
        const str = [];
        
        for(const prop in obj){
            if (obj.hasOwnProperty(prop) && obj[prop] !== undefined) {
                str.push(encodeURIComponent(prop) + "=" + encodeURIComponent(obj[prop]));
            }
        }
        
        return str.join("&");
    }
}